import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  center: {
    textAlign: "center",
  },
  progress: {
    margin: theme.spacing(2),
  },
}));

const Loading = () => {
  const classes = useStyles();

  return (
    <div className={classes.center}>
      <CircularProgress className={classes.progress} />
    </div>
  );
};

export default Loading;
